import type { $Fetch } from "ofetch";

/**
 * Nome do Controller da API
 */
const controller = "/uf";

/**
 * Classe de gerenciamento de chamadas da API dos módulos
 *
 * @class
 */
export default class UfApi {
  /**
   * Instância da dependência da API (ofetch)
   */
  private api;

  /**
   * Cria uma nova instância da classe UfApi.
   * @constructor
   * @param api - Instância da dependência da API (ofetch).
   */
  constructor(api: $Fetch) {
    this.api = api;
  }

  /**
   * @returns Lista de Ufs
   */
  list() {
    return this.api<ApplicationModule[]>(`${controller}/uf`, {
      method: "GET",
    });
  }

  /**
    * @returns Lista de municípios
    */
  listMunicipios(UF: string, tabelaMunicipioNfsGoiania: boolean) {
    return this.api<ApplicationModule[]>(`${controller}/municipio`, {
      method: "GET",
      params: {
        uf: UF,
        tabelaMunicipioNfsGoiania
      }
    });
  }
}
